var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5415 17.6665H19.2907L18.8473 17.239C19.8368 16.0895 20.56 14.7354 20.9651 13.2737C21.3702 11.8121 21.4473 10.2789 21.1907 8.78401C20.4465 4.38234 16.7732 0.867338 12.3398 0.329005C10.7812 0.131825 9.19817 0.29381 7.71179 0.802562C6.22542 1.31131 4.87512 2.15335 3.76424 3.26424C2.65335 4.37512 1.81131 5.72542 1.30256 7.21179C0.79381 8.69817 0.631825 10.2812 0.829005 11.8398C1.36734 16.2732 4.88234 19.9465 9.28401 20.6907C10.7789 20.9473 12.3121 20.8702 13.7737 20.4651C15.2354 20.06 16.5895 19.3368 17.739 18.3473L18.1665 18.7907V20.0415L24.8957 26.7707C25.5448 27.4198 26.6057 27.4198 27.2548 26.7707C27.904 26.1215 27.904 25.0607 27.2548 24.4115L20.5415 17.6665ZM11.0415 17.6665C7.099 17.6665 3.9165 14.484 3.9165 10.5415C3.9165 6.599 7.099 3.41651 11.0415 3.41651C14.984 3.41651 18.1665 6.599 18.1665 10.5415C18.1665 14.484 14.984 17.6665 11.0415 17.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.4ec1d4f5cfbd1954687cd96912292f22.svg";
export { ForwardRef as ReactComponent };